const hostname = import.meta.env.VITE_API_URL;

export default hostname;
